"use client";

import { capturePostHogEvent } from "~/lib/posthog/client";

type PublicNavLink = Readonly<{
  label: string;
  href: `/${string}` | "/";
}>;

const links = {
  gifts: { label: "Poklon vaučeri", href: "/gift-card" },
  availability: {
    label: "Slobodni termini",
    href: "/slobodni-termini",
  },
  therapists: {
    label: "Svi terapeuti",
    href: "/terapeuti",
  },
  therapy: {
    label: "Vrste terapije",
    href: "/terapija",
  },
  couples: {
    label: "Terapija za parove",
    href: "/terapija/za-parove",
  },
  guide: {
    label: "Vodič kroz psihoterapiju",
    href: "/vodic-kroz-psihoterapiju",
  },
  tests: {
    label: "Testovi",
    href: "/testovi",
  },
  blog: {
    label: "Blog",
    href: "/blog",
  },
  tijana: {
    label: "Tijana AI psiholog",
    href: "/tijana",
  },
  questionnaire: {
    label: "Popuni upitnik",
    href: "/upitnik",
  },
} as const satisfies Record<string, PublicNavLink>;

export const PUBLIC_NAVIGATION = {
  primary: [links.therapists, links.therapy, links.guide, links.gifts],
  mobile: {
    support: [
      links.availability,
      links.therapists,
      links.therapy,
      links.couples,
    ],
    questionnaire: links.questionnaire,
    resources: [links.guide, links.gifts, links.tests, links.blog, links.tijana],
  },
} as const;

export type PublicNavDestination = (typeof links)[keyof typeof links]["href"];

export type PublicNavLocation = "public_header" | "public_mobile_menu";

export function trackPublicNavClick({
  destination,
  location,
}: {
  destination: PublicNavDestination;
  location: PublicNavLocation;
}): void {
  capturePostHogEvent("nav_clicked", {
    destination,
    source_path: window.location.pathname,
    location,
  });
}
